import { useRef, useCallback } from 'react';

export const useScrollToTopHTMLElement = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);

  const scrollToTop = useCallback(() => {
    ref.current?.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  }, []);

  return { ref, scrollToTop };
};
